"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.QNA_TYPE = exports.QNA_STATUS = void 0;
exports.QNA_STATUS = {
    CREATED: 'created',
    OPEN: 'open',
    CLOSED: 'closed',
};
exports.QNA_TYPE = {
    QUESTION: 'question',
    ANSWER: 'answer',
};
